<template>
    <div class="item-content" @click="goDetail(item)">
        <div
            class="item-img"
            :style="{
                backgroundImage: `url(${
                    item.imageUrl ||
                    'https://pic.downk.cc/item/5e86f8d8504f4bcb04b99b25.png'
                })`,
            }"
        >
            <Svgs
                class="ele-icon"
                color="#f8f8f8"
                :name="'icon' + item.sourceCode"
            ></Svgs>
            <Svgs
                class="isBookable"
                v-if="item.isBookable"
                name="iconbiaoqianyuyue1"
            ></Svgs>
        </div>
        <div class="item-msg">
            <h5>{{ item.restaurantName }}</h5>
            <div class="msg-des">
                <van-icon name="star" color="#FFCD30" />
                <span class="yellow">
                    {{ item.rating }}
                </span>
                <span v-if="item.recentOrderNum"> 月售：{{ item.recentOrderNum }} </span>
            </div>
            <div class="msg-des flex-container">
                <span>
                    起送:¥{{ item.deliverAmount }} <span v-if="item.agentFee">配送:¥{{ item.agentFee }}</span>
                </span>
                <span v-if="item.deliverSpent">
                    {{ item.deliverSpent }}分钟
                    {{ item.distance | distance }}
                </span>
            </div>
            <div
                class="tag-container"
                :class="{ hidden: icon === 'down' }"
                :id="'tag-container' + item.erestaurantId"
            >
                <van-tag
                    plain
                    :color="color"
                    v-for="(act, index) in activity"
                    :key="'act' + index"
                >
                    {{ act }}
                </van-tag>
                <van-icon
                    v-show="icon == 'up'"
                    @click.native.stop="hidden"
                    name="arrow-up"
                />
                <van-icon
                    v-show="icon == 'down'"
                    @click.native.stop="show"
                    name="arrow-down"
                />
            </div>
        </div>
    </div>
</template>
<script>
import { mapMutations, mapGetters } from "vuex";
import { colors } from "@/utils/js/colors.js";
export default {
    data() {
        return {
            icon: "",
        };
    },
    props: ["item"],
    computed: {
        ...mapGetters(["eventData"]),
        activity() {
            let activities = this.item.activities || [];
            activities = activities.filter((item) => item.detailType == 102);
            let des = "";
            if (activities.length) {
                des = activities[0].description.replace(/元/g, "");
                des = des.replace(/满/g, "");
                return des.split("，");
            }
        },
        color() {
            return colors[this.eventData.tenant_code];
        },
    },
    mounted() {
        let erestaurantId = this.item.erestaurantId;
        let className = "tag-container" + erestaurantId;
        let height = document.getElementById(className).offsetHeight;
        if(document.getElementsByClassName("van-tag")[0]) {
            let tagHeight = document.getElementsByClassName("van-tag")[0]
            .offsetHeight;
            if (height > 2 * tagHeight) {
                this.icon = "down";
            }
        }
    },
    methods: {
        ...mapMutations(["SHOP_DETAIL"]),
        // 进入详情页
        goDetail(item) {
            this["SHOP_DETAIL"](item);
            this.$router.push(`/ele/shopDetail?rnd=${new Date().getTime()}`);
        },
        show() {
            this.icon = "up";
        },
        hidden() {
            this.icon = "down";
        },
    },
    filters: {
        distance: (val) => {
            let dis = (val || 0).toFixed(0);
            if (dis.length > 3) {
                return `${(dis / 1000).toFixed(1)}km`;
            } else {
                return dis + "m";
            }
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.item-content {
    display: flex;
    padding: $smart-padding-base;
    margin: 0.2rem 0;

    .van-tag {
        margin: 0 0.05rem 0.05rem 0;
    }
}
.item-img {
    background-size: cover;
    width: 0.8rem;
    height: 0.8rem;
    margin-right: 0.17rem;
    border-radius: 0.1rem;
    position: relative;
    background-position: center;

    .ele-icon {
        position: absolute;
        bottom: 0.05rem;
        right: 0.05rem;
    }

    .isBookable {
        position: absolute;
        top: -0.1rem;
        left: 0;

        .icon {
            width: 0.3rem !important;
            height: 0.3rem !important;
        }
    }
}
.item-msg {
    width: calc(100% - 0.97rem);
    h5 {
        font-size: 0.16rem;
        margin: 0;
        line-height: 0.24rem;
        @include ellipsis();
    }
    .yellow {
        color: #ffcd30;
        margin-right: 0.08rem;
    }
    .msg-des {
        color: $smart-color-info;
        font-size: 0.12rem;
        line-height: 0.18rem;
    }
    .flex-container {
        display: flex;
        justify-content: space-between;
    }
    .tag-container {
        margin-top: 0.03rem;
        padding-right: 0.2rem;
        position: relative;
        transition: all 0.38s;
        max-height: 1rem;

        .van-icon {
            position: absolute;
            right: 0;
            top: 0.04rem;
        }
    }

    .hidden {
        overflow: hidden;
        max-height: 0.2rem;
        padding-right: 0.2rem;
        position: relative;
    }
}
</style>